<ion-content class="ion-padding">
  <curbnturf-register [inModal]="true"></curbnturf-register>
</ion-content>
